import Service from './abstract';
import { dataURLtoFile, getRequestHash } from "../utils/helpers";
import CuotitasError from '../utils/cuotitasError';
import loanevents, { STEPS } from './loanevents'
import { asyncService } from '../utils/AsyncService';
import { errorsKeys } from '../constants/errorTypes';

function getFirstFiles(files, number) {
    const theme = document.getElementById('root').getAttribute('theme')
    switch (theme) {
        case 'cuotitas': return files.slice(0);
        case 'cuota-ya': return files.slice(0, number);
        default: return files.slice(0);
    }
}

export class Signs extends Service {
    constructor() {
        super('signs')
    }

    // point to local signs microservice
    // get baseURL() {
    //     return `http://localhost:64052`
    // }

    endpointPDF(requestFileId, pdfId) {
        loanevents.step(STEPS.ACTIONS.FIND_CONTRACT, { metadata: { requestFileId, pdfId } })
        return `${this.baseURL}/signs/cuotitas/requestsFiles/${requestFileId}/files/${pdfId}/download`
    }

    async getPDF(contract) {
        loanevents.step(STEPS.ACTIONS.DOWNLOAD_CONTRACT, { metadata: { contract } })

        const requestId = contract.id
        const pdfId = contract.pdfId

        const url = `/signs/cuotitas/requestsFiles/${requestId}/files/${pdfId}/download`

        return this.get(url, { responseType: 'blob' })
            .then(response => response.data || response)
            .catch(() => {
                console.error(`ERROR DOWNLOADING PDF FROM ${url}`);
                throw new CuotitasError({
                    type: 'PDF DOWNLOAD',
                    message: 'Error al generar documento pdf para descarga.',
                });
            })
    }

    async getUser() {
        try {
            const requestHash = getRequestHash();

            if (!requestHash) {
                throw new CuotitasError({ type: "Not Found", message: "Página no encontrada." });
            }

            const response = await this.get(`/signs/cuotitas/requests/getbyhash/${requestHash}`);

            // if (parseInt(response.status) !== 200) {
            //     throw new CuotitasError({ type: "Error Fetching Data", message: "Error al intentar recuperar la información." });
            // }

            if (response.length < 1) {
                throw new CuotitasError({ type: "Request Not Found", message: "No se ha encontrado un pedido asociado." });
            }

            const requestId = response.id;

            const attempts = response.attempts;
            localStorage.setItem('attempts', attempts);

            const userName = response.person.attributes
                .find((attrib) => attrib.description === "first_name")
                .value;

            let gender = response.person.attributes
                .find((attrib) => attrib.description === "gender")
                .value || 'm';

            const dni = response.person.attributes
                .find((attrib) => attrib.id_document_type === 1)
                .description;

            const contracts = response.request_files
                .map((contract) => {
                    if (parseInt(contract.id_cuotitas_request) !== parseInt(requestId)) {
                        return null;
                    }

                    return {
                        id: contract.id,
                        pdfId: contract.file.id || contract.id_file,
                        requestId: contract.id_cuotitas_request,
                        signed: contract.signed,
                        informative: contract.informative
                    };
                });

            const payload = {
                gender,
                userName,
                dni,
                contracts: getFirstFiles(contracts, 5),
                requestId,
                attempts,
                hash: requestHash,
                faceliveness_validation: response.faceliveness_validation || 0,
            };

            await loanevents.step(STEPS.ACTIONS.FIND_SIGN, { id_sign_request: payload.requestId, metadata: { sign_request: payload } })

            return payload;
        } catch (error) {
            throw error?.response?.data;
        }
    }

    async postFaceLivenessLogin(hash, requestId, faceLivenessImageUrl, setToken) {
        loanevents.step(STEPS.ACTIONS.SUBMIT_SELFIE);

        if (!hash || !requestId || !faceLivenessImageUrl) {
            throw new Error('INVALID FACE LIVENESS LOGIN DATA');
        }

        const data = { hash, faceLivenessImageUrl };

        try {
            const response = await asyncService(
                (qs) => this.post(`/signs/cuotitas/login/${requestId}`, { data, qs }),
                3000
            );

            const token = response?.access_token;

            if (!token) {
                throw new CuotitasError({ type: 'Login error', message: 'Access token is not valid or missing' });
            }

            if (typeof setToken === 'function') {
                setToken(token);
            }
            this.setToken(token);

            return response;
        } catch (error) {
            const errorTypes = Object.values(errorsKeys).map(error => error.type).filter(e => e !== undefined);
            if (error.response && errorTypes.includes(error.response.data.extra.key)) {
                throw error?.response?.data;
            }
            throw new CuotitasError(error);
        }
    }

    async postSelfie(data, setToken, requestId) {
        loanevents.step(STEPS.ACTIONS.SUBMIT_SELFIE)

        if (!(data.selfie1 || data.selfie2)) {
            throw new Error('INVALID SELFIE DATA');
        }

        try {
            const response = await asyncService((qs) => this.post(`/signs/cuotitas/login/${requestId}`, { data, qs }), 3000);
            
            // if (response.status !== 200) {
            //     throw new CuotitasError({ type: 'VU error', message: 'No hemos podido validar tu identidad' });
            // }

            const token = response?.access_token;

            if (!token) {
                throw new CuotitasError({ type: 'Login error', message: 'Access token is not valid or missing' });
            }

            setToken(token);
            this.setToken(token)

            return response;
        } catch (error) {
            const errorTypes = Object.values(errorsKeys).map(error => error.type).filter(e => e !== undefined);
            if ( error.response && errorTypes.includes(error.response.data.extra.key)) {
                console.log('entra al error');
                throw error?.response?.data;
            }
            console.log('ERROR LOGING IN', error);
            throw new CuotitasError(error);
        }
    }

    async postDocument(photoUri, requestId) {
        loanevents.step(STEPS.ACTIONS.SUBMIT_DNI)

        const frontDocumentPhoto = dataURLtoFile(photoUri.front, 'front');
        const backDocumentPhoto = dataURLtoFile(photoUri.back, 'back');

        const data = new FormData();

        data.append('front', frontDocumentPhoto);
        data.append('back', backDocumentPhoto);

        try {
            const response = await this.post(`/signs/cuotitas/dni/${requestId}`, {
                data,
                headers: {
                    'Access-Control-Allow-Origin': '*'
                },
            });
            // if (response.status !== 200) {
            //     throw new Error('Something went wrong');
            // }

            return response;
        } catch (error) {
            throw new Error(error);
        }
    }

    async postSignature(requestId, data) {
        loanevents.step(STEPS.ACTIONS.SUBMIT_SIGN)

        if (!requestId || !data.signature || !data.selfie1) {
            throw new Error('INVALID SINGATURE DATA');
        }

        try {
            const response = await this.post(`/signs/cuotitas/sign/${requestId}`, { data });

            // if (response.status !== 200) {
            //     throw new Error('Something went wrong');
            // }

            return response;
        } catch (error) {
            throw new Error(error);
        }
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
export default new Signs()
